import { formatRgb, oklch, parse } from "culori";
function oklchToRgb(oklchString) {
    try {
        const oklchObj = parse(oklchString);
        if (!oklchObj) return null;
        return formatRgb(oklch(oklchObj));
    } catch (e) {
        console.error('Error converting OKLCH to RGB:', e);
        return null;
    }
}
export { oklchToRgb };
